import { Component } from '@angular/core';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { LoaderService } from '../../services/loader.service';
import { fa } from 'intl-tel-input/i18n';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-page-loader',
    imports: [ProgressSpinnerModule, TranslateModule],
    templateUrl: './page-loader.component.html',
    styleUrl: './page-loader.component.scss',
    animations: [
        fadeInOnEnterAnimation(),
        fadeOutOnLeaveAnimation()
    ]
})
export class PageLoaderComponent {
  loaderText:string='';
  isLoading:boolean = false;

  

  constructor(private loaderService:LoaderService) {
    this.loaderService.isLoading$.subscribe((value:boolean) => {
      this.isLoading = value;
    });
    this.loaderService.loaderText$.subscribe((value:string) => {
      this.loaderText = value;
    })
  }

}
